import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AttivitaNuova from './AttivitaNuova'
import AttivitaRunningExt from './AttivitaRunningExt'

import 'react-date-picker/index.css'

class AttivitaCorrente extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.onChange = this.onChange.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext){
        //console.log("componentWillReceiveProps")
        // if (this.state.orarioCliccato !== nextProps.orarioCliccato){
        //     this.setState({orarioCliccato: nextProps.orarioCliccato});
        // }
    }


    onChange() {
        if (this.props.onChange)
        {
            this.props.onChange();
        }
    }

    render() {
        let content = null;
        if (this.props.item === undefined) {
            content = <AttivitaNuova
                giorno={this.props.giorno}
                commessa={this.props.commessa}
                itemPrev={this.props.itemPrev}
                nota={this.props.nota}
                inizio={this.props.inizio}
            />
        }
        else {
            content = <AttivitaRunningExt
                giorno={this.props.giorno}
                item={this.props.item}
                onChange={this.onChange}
                onDeleteClick={this.props.onDeleteClick}
                elapsedTimeFromNow={false}
                fine={this.props.inizio}
            />
        }

        return (

            <div className="ui segment">
                {content}
            </div>
        )
    }
}

AttivitaCorrente.PropTypes = {
    item: PropTypes.object.isRequired,      // Attività corrente, se iniziata. Altrimenti undefined.
    itemPrev: PropTypes.object.isRequired,  // Ultima Attività registrata nel giorno se sistente. Altrimenti undefined.
    giorno: PropTypes.string.isRequired,
    commessa: PropTypes.object.isRequired,
    nota: PropTypes.string.isRequired,
    inizio: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onDeleteClick: PropTypes.func,
}

export default AttivitaCorrente;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaCorrente.jsx
 **/